import {
  convertDateStringToLocalDate,
  getLocalTodayMidnight,
} from '@mosey/utils/dates';
import { BaseTask, Task, TaskRef, TaskStatus, TaskType } from './types';
import { formatDateFromString } from '../../../utils/format';
import { components } from '@mosey/api-types';

type TasksAlert = components['schemas']['TasksAlert'];

export const isTaskTodo = ({ status }: BaseTask) => status === TaskStatus.todo;

export const getNextTask = (tasks: TaskRef[], taskId?: BaseTask['id']) => {
  if (taskId) {
    const currentIndex = tasks.findIndex(({ id }) => id === taskId) + 1;

    return tasks
      .slice(currentIndex)
      .concat(tasks.slice(0, currentIndex))
      .find(isTaskTodo);
  }

  return tasks.find(isTaskTodo);
};

export const isTaskOverdue = ({ status, source }: Task | TaskRef) => {
  if (source.type === TaskType.requirement && 'due_date' in source) {
    const { due_date: dueDate, managed_provider: managedProvider } = source;

    if (managedProvider) {
      return false;
    }

    if (dueDate && status !== TaskStatus.done) {
      const localToday = getLocalTodayMidnight();
      const localDueDate = convertDateStringToLocalDate(dueDate);

      return localDueDate < localToday;
    }
  }

  return false;
};

export const getTaskDueDate = ({ status, source }: Task | TaskRef) => {
  return source.type === TaskType.requirement &&
    'due_date' in source &&
    status === TaskStatus.todo &&
    source.due_date
    ? formatDateFromString(source.due_date, {
        month: 'short',
        day: 'numeric',
        year: 'numeric',
      })
    : null;
};

export const sortTaskAlerts = (a: TasksAlert, b: TasksAlert) => {
  if (a.region !== null && b.region !== null) {
    if (a.region?.name < b.region?.name) {
      return -1;
    } else if (a.region?.name > b.region?.name) {
      return 1;
    }
  }

  return 0;
};
